<template>
  <div>
    <CartSummary></CartSummary>
    <PoweredByMikMak></PoweredByMikMak>
  </div>
</template>

<script>

  import PoweredByMikMak from './PoweredByMikMak'
  import CartSummary from './CartSummary'

  export default {
    props: [],
    data() { return {} },
    components: {
      PoweredByMikMak,
      CartSummary
    },
    mounted() {
      this.initAmplitude()
    },
    computed: {
      cartId() {
        return this.$route.params.cartId
      },
      currentCart() {
        // TODO here is where we'll have to request cart.
        // firebaseService.getCart(this.cartId).then(...)...
      }
    },
    methods: {
      isTest() {
        return window.location.search.indexOf('testmagic') != -1
      },
      initAmplitude() {
        let self = this
        if (!amplitude) {
          setTimeout(() => {
            self.initAmplitude()
          }, 100)
          return
        }
        if (this.isTest()) {
          // amplitude: mikmak-magic-dev
          amplitude.getInstance().init('eff46ab0ca81ca3b5ba204caf889f2eb')
        } else {
          // amplitude: mikmak-magic-prod
          amplitude.getInstance().init('d5ca8bcb9fa8a62d3d566b3966ebe39c')
        }
      }
    },
    watch: {}
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// MagicCart.vue?16a3f017